import { Component } from '@angular/core'

@Component({
  selector: 'mb-clipboard-popup',
  templateUrl: './clipboard-popup.component.html',
  styleUrls: ['./clipboard-popup.component.scss']
})
export class ClipboardPopupComponent {
}
